import { useContext, useEffect, useState } from "react";
import styles from "./Transfer.module.css";
import { SupportEmail } from "../../common/SupportFooter";
import { Header } from "../../common/Header";
import { AmountSection } from "../../common/AmountSection";
import { RoutingContext } from "../../../context/Router";
import { MobileWrapper } from "../../common/MobileWrapper";
import { Details } from "./Details";
import { StatusMessage } from "../../StatusMessage";
import { BackToMethods } from "../../common/BackToMethods";
import { StatusContext } from "../../../context/Status";
import Loader from "../../common/Loader";
import { Processing } from "../../common/Processing";
import { BankTransferContext } from "../../../context/BankTransfer";

export const BankTransferMethod = () => {
  const { email, currency, amount, payData } = useContext(RoutingContext);
  const { pageTransactionStatus } = useContext(StatusContext);
  const { transferDetailsLoading, transferDetails, transactionRef } =
    useContext(BankTransferContext);

  if (
    pageTransactionStatus === "error" ||
    pageTransactionStatus === "success"
  ) {
    return <StatusMessage type={pageTransactionStatus} />;
  }

  return (
    <MobileWrapper>
      <Loader isLoading={transferDetailsLoading} />
      <div className={styles.container}>
        <div className={styles.main}>
          <Header email={email} />
          <AmountSection amount={amount} currency={payData?.details?.currency}/>
          <div className={styles.body}>
            {pageTransactionStatus === "idle" && (
              <Details
                bankName={transferDetails.transfer_bank}
                accName="Klasha"
                accNum={transferDetails.transfer_account}
                transactionRef={transactionRef}
                isLoading={transferDetailsLoading}
              />
            )}
            {pageTransactionStatus === "processing" && (
              <Processing transactionRef={transactionRef} />
            )}
          </div>
          {pageTransactionStatus !== "processing" && <BackToMethods />}
        </div>
        <SupportEmail />
      </div>
    </MobileWrapper>
  );
};
